export default {
  textField: 50,
  textArea: 250,
  textEditor: 6000,
}
